import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  FormGroup,
  Label,
  Input,
  Form,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import swal from "sweetalert";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import {
  applyClassToCharacters,
  getStringFromJSX,
  LoadingSpinner,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetSelectedLanguage } from "../helper/Method";
import { ApiFund } from "../funds/ApiFund";
//#endregion

const ACTION_TYPES = {
  APPROVE: 1,
  REJECT: 2,
  HOLD: 3,
};
const FundsInfaqAmanatApprovalForm = ({
  setViewInfaqAmanatApprovalForm,
  notificationId,
  setRefreshList,
}) => {
  const toggle = () => setViewInfaqAmanatApprovalForm(false);
  const [loading, setLoading] = useState(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleDrag = (e, ui) =>
    setPosition((p) => ({ x: p.x + ui.deltaX, y: p.y + ui.deltaY }));
  //#region stateSection

  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const memberId = parseInt(encryptStorage.getItem("memberId"));
  const responsibilityId = parseInt(encryptStorage.getItem("responsibilityId"));

  const { t } = useTranslation();

  const [state, setState] = useState({
    defaulValue: true,

    notificationAction: {
      code: ACTION_TYPES.APPROVE,
      notificationId,
      createdById: memberId,
      responsibilityId,
      comments: "",
      loggedInUnitId,
    },
  });
  const handleApprovalStatus = (code) => {
    setState((prev) => ({
      ...prev,
      defaulValue: code === ACTION_TYPES.APPROVE,
      notificationAction: {
        ...prev.notificationAction,
        code,
      },
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      notificationAction: {
        ...prev.notificationAction,
        [name]: value,
      },
    }));
  };
  const validate = () => {
    let temp = {};

    return Object.keys(temp).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const res = await ApiFund().UpdateNotificationInfaqToAmanat(
        state.notificationAction
      );

      if (res.data.statusCode === "200") {
        swal({
          title: t("transactions_tranfer_request_completed"),
          icon: "success",
          buttons: "OK",
        });
        setRefreshList((prev) => !prev);
      } else {
        swal({
          title: t(res.data.message) || res.data.message || t("transactions_error_handling_request"),
          icon: "error",
          buttons: "OK",
          className: GetSelectedLanguage() === "en" ? "en" : "ur",
        });
      }
    } catch (err) {
      console.error(err);
      swal({
        title: t(err.response?.data) || err,
        icon: "error",
        buttons: "OK",
        className: GetSelectedLanguage() === "en" ? "en" : "ur",
      });
    } finally {
      setLoading(false);
      setViewInfaqAmanatApprovalForm(false);
    }
  };
  //#endregion stateSection
  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal size="xl" isOpen className="inmodal">
        <ModalHeader className="modal-title">
          <GetLanguageString props="common_changes" />
        </ModalHeader>

        {loading ? (
          <ModalBody className="text-center py-4">
            <LoadingSpinner />
          </ModalBody>
        ) : (
          <>
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                <div className="ibox-content">
                  {/* Action Radio Buttons */}
                  <FormGroup>
                    <Label className="m-0">
                      <h4>{<GetLanguageString props="common_action" />}</h4>
                    </Label>
                    <Row>
                      <Col md="4" className="text-center">
                        <Label className="col-form-label">
                          <Input
                            type="radio"
                            name="code"
                            className="m-1"
                            value={ACTION_TYPES.APPROVE}
                            checked={state.defaulValue}
                            onChange={() =>
                              handleApprovalStatus(ACTION_TYPES.APPROVE)
                            }
                          />
                          <GetLanguageString props="notifications_action_approve" />
                        </Label>
                      </Col>

                      <Col md="4" className="text-center">
                        <Label className="col-form-label">
                          <Input
                            type="radio"
                            name="code"
                            className="m-1"
                            value={ACTION_TYPES.REJECT}
                            onChange={() =>
                              handleApprovalStatus(ACTION_TYPES.REJECT)
                            }
                          />{" "}
                          {
                            <GetLanguageString props="notifications_action_reject" />
                          }
                        </Label>
                      </Col>
                      <Col md="4" className="text-center">
                        <Label className="col-form-label">
                          <Input
                            type="radio"
                            name="code"
                            className="m-1"
                            value={ACTION_TYPES.HOLD}
                            onChange={() =>
                              handleApprovalStatus(ACTION_TYPES.HOLD)
                            }
                          />{" "}
                          {<GetLanguageString props="notifications_hold" />}
                        </Label>
                      </Col>
                    </Row>
                  </FormGroup>

                  <Row>
                    <Label className="col-form-label">
                      <h4>
                        {
                          <GetLanguageString props="member_member_detail_course_comments" />
                        }
                      </h4>
                      <Input
                        type="text"
                        name="comments"
                        className={`no-drag`}
                        value={getStringFromJSX(
                          applyClassToCharacters(
                            state.notificationAction.comments,
                            "ur"
                          )
                        )}
                        onChange={handleInputChange}
                      />
                    </Label>
                  </Row>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="white" onClick={toggle}>
                  {<GetLanguageString props="common_cancel" />}
                </Button>
                <Button
                  color="primary"
                  disabled={state.buttonDisable}
                  type="submit"
                >
                  {<GetLanguageString props="common_save_changes" />}
                </Button>
              </ModalFooter>
            </Form>
          </>
        )}
      </Modal>
    </Draggable>
  );
};

export default FundsInfaqAmanatApprovalForm;
